import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_BASE

const request = axios.create({
  baseURL: API_BASE,
  timeout: 12000,
  headers: { 'Content-Type': 'application/json' }
})

function notify (message) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('portal-message', { detail: message }))
  }
}

request.interceptors.response.use(
  response => {
    const body = response.data || {}
    if (body.code === 200) return body.data
    notify(body.message || '请求失败')
    return Promise.reject(new Error(body.message || '请求失败'))
  },
  error => {
    const message = error.response && error.response.data && error.response.data.message
    notify(message || '网络请求失败，请稍后重试')
    return Promise.reject(new Error(message || '网络请求失败，请稍后重试'))
  }
)

export default request
